import { BlockquoteButton } from './BlockquoteButton';
import { EquationButton } from './EquationButton';
import { HighlightButton } from './HighlightButton';
import { HighlightPalette } from './HighlightPalette';
import { TextEditorInput } from './Input';
import { UnderlineButton } from './UnderlineButton';

export const TextEditor = {
  Input: TextEditorInput,
  BlockquoteButton: BlockquoteButton,
  HighlightButton: HighlightButton,
  UnderlineButton: UnderlineButton,
  EquationButton: EquationButton,
  HighlightPalette: HighlightPalette,
};
